export default "https://cdn-static.gokick.com/assets/0b66121a981ee5d829a48c6e4fd91363599ac59b/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";